import { Link } from 'react-router-dom';
import { categories, articles } from '@/mocks/data';
import ArticleCard from '@/components/feature/ArticleCard';

const categoryNameMap: Record<string, string> = {
  'gaoxiao-shipin': '搞笑视频',
  'gaoxiao-duanzi': '搞笑段子',
  'biaoqingbao': '表情包',
  'shenpinglun': '神评论',
  'qipa-shijian': '奇葩事件',
  'shadiao-shunjian': '沙雕瞬间',
};

const latestArticles = articles.slice(0, 6);
const trendingArticles = articles.slice(6);

export default function HomePage() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '搞笑排行榜',
    url: 'https://ggqcmf.cn/',
    description: '搞笑排行榜汇聚全网最火爆的搞笑视频、段子、表情包排行榜，每日更新最好笑的内容TOP10。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://ggqcmf.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <div className="min-h-screen">
      <script type="application/ld+json">{JSON.stringify(structuredData)}</script>

      {/* Hero Section */}
      <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=A%20vibrant%20energetic%20illustration%20of%20a%20comedy%20and%20entertainment%20theme%20with%20floating%20laughing%20emoji%20elements%20confetti%20and%20playful%20abstract%20shapes%20in%20warm%20coral%20orange%20and%20golden%20yellow%20gradients%20clean%20airy%20background%20with%20subtle%20texture%20modern%20joyful%20design%20energy&width=1600&height=900&seq=hero-funny-ranking&orientation=landscape"
            alt="搞笑排行榜 - 全网最好笑内容TOP榜单合集"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/40"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 max-w-3xl leading-tight">
            全网最好笑内容<span className="text-primary-400">TOP榜单</span>合集
          </h1>
          <p className="text-white/80 text-base md:text-lg max-w-xl mb-8 leading-relaxed">
            搞笑视频、段子、表情包、神评论、奇葩事件、沙雕瞬间——每日更新最好笑的内容TOP10，摸鱼必备解压神器！
          </p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link
              to="/category/gaoxiao-duanzi"
              className="px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始看排行榜
            </Link>
            <Link
              to="/about"
              className="px-6 py-3 bg-white/15 text-white rounded-full font-medium text-sm hover:bg-white/25 transition-colors backdrop-blur-sm whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </section>

      {/* Category Navigation */}
      <section className="max-w-7xl mx-auto px-4 md:px-6 -mt-10 relative z-10">
        <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 grid grid-cols-3 md:grid-cols-6 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-3 rounded-lg hover:bg-primary-50 transition-colors group cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors text-lg">
                <i className={cat.icon}></i>
              </span>
              <span className="text-xs font-medium text-foreground-700 group-hover:text-foreground-900 text-center whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </section>

      {/* Latest Rankings */}
      <section className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新排行榜
            </h2>
            <p className="text-foreground-500 text-sm mt-1">每日更新最好笑的内容TOP10</p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {latestArticles.map((article) => (
            <ArticleCard
              key={article.slug}
              slug={article.slug}
              title={article.title}
              category={article.category}
              categoryName={categoryNameMap[article.category] || article.category}
              coverImage={article.coverImage}
              excerpt={article.excerpt}
              publishDate={article.publishDate}
              viewCount={article.viewCount}
              commentCount={article.commentCount}
              tag={article.tag}
            />
          ))}
        </div>
      </section>

      {/* Trending Rankings */}
      <section className="bg-background-100 py-14">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                热门推荐
              </h2>
              <p className="text-foreground-500 text-sm mt-1">上期精彩回顾，不容错过</p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {trendingArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 group cursor-pointer overflow-hidden"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  {article.tag && (
                    <div className="absolute top-3 right-3 px-2 py-0.5 bg-accent-500 text-background-50 rounded text-xs font-medium">
                      {article.tag}
                    </div>
                  )}
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs text-primary-600 bg-primary-100 px-2.5 py-0.5 rounded-full font-medium whitespace-nowrap">
                      {categoryNameMap[article.category] || article.category}
                    </span>
                    <span className="text-xs text-foreground-400">{article.publishDate}</span>
                  </div>
                  <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.viewCount >= 10000 ? `${(article.viewCount / 10000).toFixed(1)}万` : article.viewCount}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      {article.commentCount}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Why Us */}
      <section className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            为什么选择搞笑排行榜？
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            我们用心筛选全网最搞笑的内容，只为给你最好的摸鱼体验
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70">
            <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className="ri-shield-check-line text-2xl"></i>
            </div>
            <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">精选内容</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              每期榜单都经过编辑团队精心筛选，确保每一个上榜内容都实至名归，绝不凑数充量。
            </p>
          </div>
          <div className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70">
            <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
              <i className="ri-refresh-line text-2xl"></i>
            </div>
            <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">每日更新</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              每天都有新鲜出炉的榜单，紧跟热点不落伍。睡前一刷，烦恼全消，第二天元气满满。
            </p>
          </div>
          <div className="text-center p-6 rounded-xl bg-background-50 border border-background-200/70">
            <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
              <i className="ri-user-heart-line text-2xl"></i>
            </div>
            <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">百万粉丝信赖</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              全网累计百万粉丝关注，日均访问量超50万。用户口碑见证，搞笑排行榜值得信赖。
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}